import { AltAccTabFormStructure } from '@common/components/my-account/tabs/alternate-account-tab/alternate-account-tab.model';
import { BackupDTabFormStructure } from '@common/components/my-account/tabs/backup-destination-tab/backup-destination-tab.model';
import { GeneralTabFormStructure } from '@common/components/my-account/tabs/general-tab/general-tab.model';
import { CVAFormType } from '@common/types';

export enum FormKey {
  General = 'generalTab',
  AlternateAccount = 'alternateAccountTab',
  BackupDestination = 'backupDestinationTab'
}

export interface MyAccFormStructure {
  [FormKey.General]: GeneralTabFormStructure;
  [FormKey.AlternateAccount]: AltAccTabFormStructure;
  [FormKey.BackupDestination]: BackupDTabFormStructure;
}

export type CVAFormStructure = CVAFormType<MyAccFormStructure>;
